import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import ErrorPageComponent from '../components/error/ErrorPage';
import { permissionsGroup, PrivilegeContext } from '../components/priviledge/PriviledgeProvider';
import { RootState } from '../redux/store';

interface AccessObject {
  action: string;
  group: permissionsGroup;
}

interface ProtectedRouteProps {
  component: React.ComponentType;
  access: AccessObject[] | AccessObject | undefined;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ component, access }) => {

  const { isAuthenticated, user } = useSelector((state: RootState) => state.auth);
  const { userCan } = useContext(PrivilegeContext)

  const errorAccessPage = <ErrorPageComponent />

  const determineAccess = () => {
    if (access !== undefined) {
      if (Array.isArray(access)) {
        const hasAccess = access.some((item: AccessObject) => !userCan(item.action, item.group));
        if (hasAccess) {
          return errorAccessPage;
        }
      }else if (!userCan(access.action, access.group)) {
        return errorAccessPage;
      }
    }
    return (component);
  };

  return (
    <>
      {(user && isAuthenticated) ? determineAccess() : null}
      {(user && !isAuthenticated) ? <Navigate to="/" /> : null}
      {(!user && !isAuthenticated) ? <Navigate to="/login" /> : null}
    </>
  );
};

export default ProtectedRoute;